import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ClientsContent from '../components/ClientsContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';
 
class Clients extends React.Component{
 
    render()
    {

        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[7].title}</title>  
                    <meta name="description" content={metas[7].meta_description} />
                    <meta name="keywords" content={metas[7].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'clients'} />
                </Helmet>
                <PageHeader title="Clients"/>
                <ClientsContent content={JSON.parse(localStorage.getItem("content"))} clients={JSON.parse(localStorage.getItem("clients"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default Clients;